import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
    /** Show a full-page overlay backdrop (default: false — inline mode) */
    @Input() overlay = false;

    /** Optional loading message */
    @Input() message = '';

    /** Size variant: 'sm' (24px), 'md' (48px), 'lg' (72px) */
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
}
